import "../styles/HomePage.scss";
import caisse from "../assets/caisse.png";
import afficheurClient from "../assets/afficheur-client.png";
import { useRef, useState } from "react";
import { PropagateLoader } from "react-spinners";
import useWebSocket from "react-use-websocket";
import { socketUrl } from "../helper";

const HomePage = () => {
    const [showPopup, setShowPopup] = useState(false);
    const [loading, setLoading] = useState(false);
    const pendingCodeRef = useRef("");

    const onWebSocketMessage = (event) => {
        const data = JSON.parse(event.data);

        if (data.action === "error") {
            const input = document.getElementById("pairingCode");
            input?.classList.add("input-error");
            setTimeout(() => {
                input?.classList.remove("input-error");
            }, 500);
            setLoading(false);
            return;
        }

        if (data.action === "refresh-categories" && pendingCodeRef.current) {
            window.location.href = `/caisse/${pendingCodeRef.current}`;
        }
    };

    const { sendMessage } = useWebSocket(socketUrl, {
        onMessage: onWebSocketMessage,
        shouldReconnect: () => true,
    });

    const handlePairingInput = (event) => {
        const value = event.target.value;

        if (value.length === 6) {
            setLoading(true);
            pendingCodeRef.current = value;
            sendMessage(JSON.stringify({
                action: "client",
                code: value,
            }));
        }
    };

    const popup = () => (
        <div className="popup">
            <div className="popup-content">
                <button className="close" onClick={() => setShowPopup(false)}>
                    <i className="fa-sharp fa-regular fa-xmark"></i>
                </button>

                <h1>Entrez le code d&apos;appairage de la caisse</h1>

                <input
                    id="pairingCode"
                    className="input"
                    type="number"
                    placeholder="000000"
                    maxLength={6}
                    onChange={handlePairingInput}
                    disabled={loading}
                />

                <PropagateLoader
                    color="#36d7b7"
                    loading={loading}
                    cssOverride={{ marginLeft: "-20px" }}
                />
            </div>
        </div>
    );

    return (
        <div className="home-page">
            <a className="agent-download" href="/downloads/CaisseFoireSetup.exe" download>
                <span className="agent-download__icon">⬇</span>
                <span className="agent-download__text">
                    <strong>Installer sur la caisse</strong>
                    <small>Windows · double écran Chrome + surveillance</small>
                </span>
            </a>

            <div className="mode-selector">
                <button onClick={() => { window.location.href = "/caisse"; }}>
                    <img src={caisse} alt="caisse" />
                </button>
                <button onClick={() => setShowPopup(true)}>
                    <img src={afficheurClient} alt="afficheur-client" />
                </button>
            </div>

            <div className="stand-links">
                <p>Écrans stands (en plus des imprimantes)</p>
                <a href="/stand/boisson">Boissons</a>
                <a href="/stand/repas">Repas</a>
                <a href="/stand/dessert">Desserts</a>
            </div>

            {showPopup && popup()}
        </div>
    );
};

export default HomePage;
